"use strict";

module.exports = require("./DataService");